import { useState, useEffect } from "react";
import { Upload } from "antd";

import Sha256Encode from "../components/sha256";
import { useGlobalState } from "./global";

export default function UploadComponent({ value, onChange, path, children, type, ...props }: any) {
    const [OSSData, setOSSData]: any = useState();

    const { jsonRequest } = useGlobalState();

    const init = async () => {
        // ”audio”：音频, “doc”：文档, “picture”：图片, “other”：其他, “video”：视频
        const result = await jsonRequest.get("/common/oss-sign", {
            type: type,
        }).then((resp: any) => resp.json())
        setOSSData(result.data)
    };

    useEffect(() => {
        init();
    }, []);

    const handleChange = ({ fileList }: any) => {
        let list: any[] = [];
        if (OSSData?.host) {
            fileList.map((item: any) => {
                if (item.url) {
                    list.push({ ...item });
                }
            });
            list.map((item: any) => { item.url = item.url?.startsWith('http') ? item.url : `${OSSData.host}/${item.url}`; })
        }
        console.log(list, 'list');
        onChange?.([...list]);
    };

    const onRemove = (file: any) => {
        // if (onChange) {
        //     onChange(files);
        // }
    };

    const getExtraData = (file: any) => ({
        key: file.url,
        OSSAccessKeyId: OSSData?.keyId,
        policy: OSSData?.policy,
        Signature: OSSData?.signature,
    });

    const beforeUpload = async (file: any) => {
        if (!OSSData) return false;

        const expire = Number(OSSData.expire) * 1000;

        if (expire < Date.now()) {
            await init();
        }

        const file_content = await file.arrayBuffer()
        const file_name = await Sha256Encode(file_content)

        file.url = [OSSData?.dir, file_name].join("/")
        return file;
    };

    const uploadProps = {
        name: 'file',
        fileList: value,
        action: OSSData?.host,
        onChange: handleChange,
        onRemove,
        data: getExtraData,
        beforeUpload,
    };

    return (
        <Upload {...props} {...uploadProps} >
            {children}
        </Upload>
    );
};
